import React from "react";
import { useSelector } from "react-redux";
import { BannerContainer, BannerImage, BannerInnerContainer, SynBannerContainer, SynInnerContainer } from "./Styles";
import stod2 from "../../../images/STod2.svg";
import vodafone from "../../../images/vf-logo.png";
import syn from "../../../images/syn-master-red.svg";
import Hamburger from "../Menu/Hamburger";
import {
  STOD2_REDIRECT,
  VODAFONE_REDIRECT,
  THEME, SYN_REDIRECT,
} from "../../../utility/constants";
import { getTheme } from "../../../redux/reducers/theme/selectors";
import Account from "../Menu/Account";

export default function Banner() {
  const theme = useSelector(getTheme);
  const redirect =
    theme === THEME.SYN ? SYN_REDIRECT : (theme === THEME.VODAFONE ? VODAFONE_REDIRECT : STOD2_REDIRECT);
  return (
    <>
      {THEME.SYN === theme
      ? (
        <SynBannerContainer>
          <SynInnerContainer>
            <BannerImage
              theme={theme}
              onClick={() => {window.location.href = redirect}}
              src={syn || ''}
              alt={theme}
            />
            <Account />
          </SynInnerContainer>
        </SynBannerContainer>
      ) : (
        <BannerContainer theme={theme}>
          <BannerInnerContainer>
            <BannerImage
              theme={theme}
              onClick={() => {window.location.href = redirect}}
              src={theme === THEME.SYN ? syn : (theme === THEME.VODAFONE ? vodafone : stod2)}
              alt={theme}
            />
            <Hamburger theme={theme} />
          </BannerInnerContainer>
        </BannerContainer>
      )
      }
    </>
  );
}
